import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/buttons";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import { useFixBody } from "@state/hooks/shared";

export default observer(function CapacitorUpdatePopup() {
	const { t } = useTranslation();

	const {
		capacitorUpdaterStore: { capacitorUpdatePopupStore },
	} = useRootAppStore();

	useFixBody(true, capacitorUpdatePopupStore.isPopupVisible);

	const canUserDeclineUpdate =
		capacitorUpdatePopupStore.shouldForceUpdate == false;

	return (
		<div className="popup">
			<div className="popup__card">
				<div className="popup__body u-padd--top--big u-padd--bottom--xsml u-type--center">
					<i className="u-icon u-icon--huge u-icon--empty u-icon--empty--app" />
					<div className="u-mar--bottom--xtny u-type--big">
						{t("CAPACITOR_UPDATE.APP_UPDATE_TITLE")}
					</div>
					<div className="u-type--base">
						<div>
							{t(
								"CAPACITOR_UPDATE.APP_UPDATE_AVAILABLE_VERSION_DESC"
							)}
						</div>
						{canUserDeclineUpdate && (
							<div>
								{t(
									"CAPACITOR_UPDATE.APP_UPDATE_DECLINE_UPDATE"
								)}
							</div>
						)}
					</div>
				</div>

				<div className="popup__footer">
					{canUserDeclineUpdate && (
						<Button
							className="popup__btn popup__btn--secondary btn btn--base btn--block btn--primary--inverted"
							btnText={t("COMMON.CANCEL")}
							onClick={capacitorUpdatePopupStore.declineUpdate}
						/>
					)}
					<Button
						className="popup__btn popup__btn--primary btn btn--base btn--block btn--accent"
						btnText={t(
							capacitorUpdatePopupStore.shouldForceNativeUpdate
								? "CAPACITOR_UPDATE.NATIVE_UPDATE_BTN"
								: "COMMON.UPDATE_BUTTON"
						)}
						onClick={capacitorUpdatePopupStore.acceptUpdate}
					/>
				</div>
			</div>
		</div>
	);
});
